<p-dialog header="Motivo de cierre" [modal]="true" 
[draggable]="false" 
[resizable]="false"
styleClass="p-dialog-firma-custom" 
[(visible)]="displayModalAusente" 
(onHide)="closeModalAusentismo()" 
[style]="{width: '600px'}">
    <p-messages [(value)]="messagesErrorPrevious" 
        [enableService]="false" 
        [showTransitionOptions]="'500ms'" 
        [hideTransitionOptions]="'500ms'" 
        [closable]="true"></p-messages>
        <div class="container">
            <div *ngFor="let motivo of motivosCierre" class="field-checkbox p-col-12 p-md-4 ">
                <p-radioButton name="group" [value]="motivo" [(ngModel)]="selectedMotivoCierre" [inputId]="motivo.codigo"></p-radioButton>
                <label [for]="motivo.codigo"> {{ motivo.descripcion }}</label>
            </div>
        </div>
    <p>
        ¿Confirma cerrar el estudio de <strong>{{ nombreEstudio }}</strong> del trabajador <strong>{{ nombreTrabajador }}</strong>?
    </p>
    <p-footer>
        <p-button (click)="closeModalAusentismo()">Cancelar</p-button>
        <p-button (click)="submitAusente()" id="clean-button">Cerrar</p-button>
    </p-footer>
</p-dialog>